import { connect } from 'react-redux'
import authActions from 'actions/auth'
import tenantActions from 'actions/tenants'
import customerActions from 'actions/customers'
import userActions from 'actions/users'
import Component from 'components/Login'

const mapDispatchToProps = {
  login: authActions.login,
  getTenantInfo: tenantActions.getTenantInfo,
  getCustomers: customerActions.getOptionsOffline,
  getSsoEnabled: userActions.getSsoEnabled,
}

export default connect(null, mapDispatchToProps)(Component)
